import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(() => ({
  borderColor: "#E9E9E9",
  fontSize: 14,
  padding: "9px 12px",
  borderRadius: 100,
  fontWeight: 400,

  "& .MuiSvgIcon-root": {
    fontSize: 8,
  },
}));
